import React from "react";
import styled from "styled-components";

/** Légende de graphique : liste de { name, color } */
const Legend = ({ items = [], ...props }) => {
    return (
        <Wrapper {...props}>
            {items.map((item) => (
                <Item key={item.name}>
                    <Swatch style={{ background: item.color }} />
                    {item.name}
                </Item>
            ))}
        </Wrapper>
    );
};

export default Legend;

const Wrapper = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 9px 15px;
    margin-top: 12px;
    font-size: 13px;
    color: var(--prh-muted);
`;

const Item = styled.span`
    display: flex;
    align-items: center;
    gap: 6px;
`;

export const Swatch = styled.span`
    width: 11px;
    height: 11px;
    border-radius: 3px;
    flex: none;
    display: inline-block;
`;
